import { APIProvider, Map } from '@vis.gl/react-google-maps';
import GeoJsonLayer from './GeoJsonLayer';
import OverlapLayer from './OverlapLayer';

const API_KEY = "AIzaSyALpDWAlpYMJc5RtcLG31oOvXYVRmwthXw";

export default function MapComponent({ children, importedFeatures, onFeatureSelect, editable = false, teamColors = {}, onClick, isPinningMode = false }) {
  return (
    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, borderRadius: 'var(--radius-lg)', overflow: 'hidden', border: '1px solid var(--color-border)' }}>
        <Map
          defaultCenter={{ lat: 13.7563, lng: 100.5018 }} // Default to Bangkok
          defaultZoom={6}
          gestureHandling={'auto'}
          disableDefaultUI={false}
          zoomControl={true}
          mapTypeControl={true}
          scaleControl={true}
          streetViewControl={false}
          keyboardShortcuts={true}
          scrollwheel={true}
          mapId="e8e6ab2c65a4c9b" // Standard Map ID to enable AdvancedMarkerElement
          onClick={onClick}
        >
          <GeoJsonLayer features={importedFeatures} onFeatureSelect={onFeatureSelect} editable={editable} teamColors={teamColors} isPinningMode={isPinningMode} onMapClick={onClick} />
          <OverlapLayer features={importedFeatures} />
          {children}
        </Map>
    </div>
  );
}
